import { useUpFetch } from '../../utils'

export * from './api'
export * from './mutations'

export const usePatchLoadStatus = ({ id }: { id: number }) => {
  const upFetch = useUpFetch()

  return async (body: { status: string }) =>
    upFetch(`/loads/${id}/status`, {
      body,
      method: 'PATCH',
    })
}

export const usePatchLoadState = ({ id }: { id: number }) => {
  const upFetch = useUpFetch()

  return async (body: { state: string }) =>
    upFetch(`/loads/${id}/state`, {
      body,
      method: 'PATCH',
    })
}
